import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'; 
import { useSelector } from 'react-redux';

import { ReactComponent as HoFBadge } from '../../../assets/icons/hof-badge.svg'
import useFetch from '../../../hooks/use-fetch';
import SocialMediaButtons from '../../UI/SocialShare';

const HoFNotice = ({showModal = false}) => {
    const {t:translate} = useTranslation();
    const { apiUrl } = window['appConfig'];
    const [isActive, setIsActive] = useState(false);
    const sceneId = useSelector((state) => state.currentSceneID);
    const {data, error, initFunc: fetchHoFStatus} = useFetch()

    useEffect(() => {
        //Forced modal show
        if( showModal ) {
            setTimeout(function() {
                setIsActive(true);
            }, 100)
        } else {
            const fetchOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            };
            fetchHoFStatus({url:`${apiUrl}/progress/scene/${sceneId}/`, options:fetchOptions});

        }
    },[])

    useEffect(() => {
        if( data ) {
            if( data?.hallOfFame === true ) {
                setIsActive(true);
            }
        } 

        if( error ) {
            console.error(error);
            setIsActive(false);
        }
    },[data, error])
    
    useEffect(() => {
        if( isActive ) {
            setTimeout(function() {
                setIsActive(false);
            }, 7500)
        }
    },[isActive])

    return (
        <div className={`hof-notice ${isActive ? 'hof-notice--active' : ''}`} onClick={() => {setIsActive(false)}}>
            <div className='hof-container'>
                <div className='hof-notice__badge'>
                    <HoFBadge />
                </div>
                <div className='hof-notice__description'>
                    <h4 className='hof-notice__title'>{translate('hof-title')}</h4>
                    <p className='hof-notice__content'>{translate('hof-description')}</p>
                </div>
            </div>
            <SocialMediaButtons code={'glhof'}/>
        </div>
    )
}

export default HoFNotice;